import styles from './OrangeCardItem.module.scss';
import { FC, useState } from 'react';
import bg from '../../assets/card.svg';
import tinkoff from '../../assets/tinkoff.svg';
import { IInvoice } from '../../types/types';
import { Button, notification } from 'antd';
import { mAxios } from '../../utils/api';
import { parseError } from '../../utils/utils';



export interface ICardProps {
    invoice: IInvoice
}


export const OrangeCardItem: FC<ICardProps> = ({invoice}) => {

    const [isDeleted, setIsDeleted] = useState(false);

    const deleteCurrentInvoice = async(cardId: number) => {
        setIsDeleted(true);
        try {
            await mAxios.delete(`payment-method/my/${cardId}`);
            setIsDeleted(false);
            window.location.reload();
        } catch (error) {
            //notification.error({message: parseError(error), duration: 3});
            setIsDeleted(false);
        }
    }

    return <>
        <div className={styles.container}>
            <img src={bg} className={styles.bg} />

            <div className={styles.data_container}>
                <div className={styles.header}>
                    <p>{invoice.nameMethod}</p>
                    <img src={tinkoff} />
                </div>

                <div>
                    <p className={styles.card_number}>{invoice.invoice.split('|')[0]}</p>
                    <p className={styles.name_on_card}>{invoice.invoice.split('|')[1].trim()}</p>
                </div>
            </div>
    
            {/* <IoIosRemoveCircleOutline className={styles.close_icon}/> */}
        
            <Button className={styles.close_icon} loading={isDeleted} onClick={() => deleteCurrentInvoice(invoice.id)}>Удалить</Button>
        </div>
    </>

}